export const loadDynamicOptions = (app) => {
  return async (dispatch, getState) => {
    const res = await fetch(
      "/wp-json/ensclient/dynamicOptions"
    ).then((res) => res.json());

    console.log("Loaded synamicOptions", res);

    dispatch({ type: "DYNAMIC_OPTIONS_LOADED", dynamicOptions: res });
  };
};
